export const sxStyles = {
    container: {
        display: "flex",
        flexDirection: "row",
        height: "100%",
        flex: 1,
        minHeight: 0,
        gap: 2
    },
    tabContainer: {
        borderRight: "1px solid",
        borderColor: "greyscale.200",
        alignItems: "flex-start",
        overflowY: "auto"
    },
    schemaContainer: {
        width: "250px",
        height: "100%",
        overflow: "hidden",
        borderRight: "1px solid",
        borderColor: "greyscale.200"
    },
    schemaItemContainer: isSchemaActive => ({
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        px: 2,
        backgroundColor: isSchemaActive ? "greyscale.100" : "transparent",
        borderTop: isSchemaActive ? "1px solid" : "none",
        borderBottom: isSchemaActive ? "1px solid" : "none",
        borderColor: "greyscale.200",
        "&:hover": {
            backgroundColor: "greyscale.100"
        },
        "& .MuiTypography-root": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "100%"
        }
    }),
    tableContainer: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        p: 2,
        gap: 2,
        "& .row-selection-disabled": {
            cursor: "not-allowed",
            "& .ag-cell[col-id='0']": {
                ml: "-10px",
                mt: "6px"
            },
            "& .ag-selection-checkbox": {
                display: "none !important"
            }
        }
    },
    tableDescContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        gap: 2
    },
    customTooltip: {
        backgroundColor: "greyscale.900",
        padding: "4px 8px",
        borderRadius: "4px",
        maxWidth: "300px"
    }
};
